import { Typography } from '@material-ui/core';

export const XText = Typography;
